import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "wbo-edit-grid-message",
    templateUrl: "./edit-grid-message.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditGridMessageComponent {

}
